// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.stars-counter {
    margin-top: auto;
}

h1 {
    font-weight: 600;
    font-size: 11.163vw;
    line-height: 13.256vw;
    text-align: center;
    color: white;
}

h4 {
    font-weight: 300;
    font-size: 3.721vw;
    line-height: 4.186vw;
    letter-spacing: 2%;
    text-align: center;
    color: #FFFFFF66;
}

h5 {
    font-weight: 400;
    font-size: 3.256vw;
    line-height: 3.886vw;
    letter-spacing: 2%;
    color: #FFFFFF66;
}

.game-page .tap-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.game-page .timer-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.energy-row {
    display: flex;
    align-items: center;
    margin-top: auto;
    margin-bottom: 3.023vw;
}

.energy-row h4{
    font-weight: 400;
    font-size: 4.186vw;
    line-height: 4.884vw;
    letter-spacing: 2%;
    color: #FFFFFF66;
    margin-right: 1.163vw;
}

.energy-counter {
    display: flex;
    padding: 1.395vw 0.93vw;
    border-radius: 10px;
    background-color: #49B2FF0D;
}

.energy-row .energy-counter{
   border: 1px solid #FFFFFF1C;
}

.game-page .tap-button-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vw;
}

.circle-text {
    z-index: 2;
    position: absolute;
    left: 50%;
    top:50%;
    font-weight: 400;
    font-size: 5.581vw;
    line-height: 7.209vw;
    letter-spacing: 2%;
    color: #FFFFFF59;
    opacity: 0;
}

.text1 { 
    transform: translateX(-50%) rotate(-45deg);
}

.text2 { 
    transform: translateX(50%) rotate(45deg);
}

.text3 { 
    transform: translateX(-50%) rotate(45deg);
}

.text4 { 
    transform: translateX(50%) rotate(-45deg);
}

.game-page .tap-button {
    position: absolute;
    z-index: 2;
    width: 290px;
    height: 290px;
    background: linear-gradient(to bottom, #D358E7, #0F165E);
    border-radius: 50%;
    border: none;
}

.game-page .tap-button image{
    width: 271px;
    height: 263px;
}

.game-page .tap-button:active {
    transform: scale(0.95);
}

.text1.active {
    animation: flowUpLeft 1s ease-out forwards;
}

.text2.active {
    animation: flowUpRight 1s ease-out forwards;
}

.text3.active {
    animation: flowDownLeft 1s ease-out forwards;
}


.text4.active {
    animation: flowDownRight 1s ease-out forwards;
}

@keyframes flowUpLeft {
    0% {
      left: 50%;
      top: 50%;
      opacity: 1;
    }
    100% {
      left: 15%;
      top: 15%;
      opacity: 0.4;
    }
}


@keyframes flowUpRight {
    0% {
      right: 50%;
      top: 50%;
      opacity: 1;
    }
    100% {
      right: 15%;
      top: 15%;
      opacity: 0.4;
    }
}

@keyframes flowDownRight {
    0% {
      right: 50%;
      bottom: 50%;
      opacity: 1;
    }
    100% {
      right: -25%;
      bottom: -25%;
      opacity: 0.4;
    }
}

@keyframes flowDownLeft {
    0% {
      left: 50%;
      bottom: 50%;
      opacity: 1;
    }
    100% {
      left: 20%;
      top: 80%;
      opacity: 0.4;
    }
}


.animation {
    position: absolute;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    animation: flyUp 1.2s ease-out forwards;
  }
  
  @keyframes flyUp {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(-100px);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/game/style/game_page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;GACG,2BAA2B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,wDAAwD;IACxD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;;AAGA;IACI,6CAA6C;AACjD;;AAEA;IACI;MACE,SAAS;MACT,QAAQ;MACR,UAAU;IACZ;IACA;MACE,SAAS;MACT,QAAQ;MACR,YAAY;IACd;AACJ;;;AAGA;IACI;MACE,UAAU;MACV,QAAQ;MACR,UAAU;IACZ;IACA;MACE,UAAU;MACV,QAAQ;MACR,YAAY;IACd;AACJ;;AAEA;IACI;MACE,UAAU;MACV,WAAW;MACX,UAAU;IACZ;IACA;MACE,WAAW;MACX,YAAY;MACZ,YAAY;IACd;AACJ;;AAEA;IACI;MACE,SAAS;MACT,WAAW;MACX,UAAU;IACZ;IACA;MACE,SAAS;MACT,QAAQ;MACR,YAAY;IACd;AACJ;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,uCAAuC;EACzC;;EAEA;IACE;MACE,UAAU;MACV,wBAAwB;IAC1B;IACA;MACE,UAAU;MACV,6BAA6B;IAC/B;EACF","sourcesContent":[".game-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.stars-counter {\n    margin-top: auto;\n}\n\nh1 {\n    font-weight: 600;\n    font-size: 11.163vw;\n    line-height: 13.256vw;\n    text-align: center;\n    color: white;\n}\n\nh4 {\n    font-weight: 300;\n    font-size: 3.721vw;\n    line-height: 4.186vw;\n    letter-spacing: 2%;\n    text-align: center;\n    color: #FFFFFF66;\n}\n\nh5 {\n    font-weight: 400;\n    font-size: 3.256vw;\n    line-height: 3.886vw;\n    letter-spacing: 2%;\n    color: #FFFFFF66;\n}\n\n.game-page .tap-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.game-page .timer-counter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.energy-row {\n    display: flex;\n    align-items: center;\n    margin-top: auto;\n    margin-bottom: 3.023vw;\n}\n\n.energy-row h4{\n    font-weight: 400;\n    font-size: 4.186vw;\n    line-height: 4.884vw;\n    letter-spacing: 2%;\n    color: #FFFFFF66;\n    margin-right: 1.163vw;\n}\n\n.energy-counter {\n    display: flex;\n    padding: 1.395vw 0.93vw;\n    border-radius: 10px;\n    background-color: #49B2FF0D;\n}\n\n.energy-row .energy-counter{\n   border: 1px solid #FFFFFF1C;\n}\n\n.game-page .tap-button-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100vw;\n    height: 100vw;\n}\n\n.circle-text {\n    z-index: 2;\n    position: absolute;\n    left: 50%;\n    top:50%;\n    font-weight: 400;\n    font-size: 5.581vw;\n    line-height: 7.209vw;\n    letter-spacing: 2%;\n    color: #FFFFFF59;\n    opacity: 0;\n}\n\n.text1 { \n    transform: translateX(-50%) rotate(-45deg);\n}\n\n.text2 { \n    transform: translateX(50%) rotate(45deg);\n}\n\n.text3 { \n    transform: translateX(-50%) rotate(45deg);\n}\n\n.text4 { \n    transform: translateX(50%) rotate(-45deg);\n}\n\n.game-page .tap-button {\n    position: absolute;\n    z-index: 2;\n    width: 290px;\n    height: 290px;\n    background: linear-gradient(to bottom, #D358E7, #0F165E);\n    border-radius: 50%;\n    border: none;\n}\n\n.game-page .tap-button image{\n    width: 271px;\n    height: 263px;\n}\n\n.game-page .tap-button:active {\n    transform: scale(0.95);\n}\n\n.text1.active {\n    animation: flowUpLeft 1s ease-out forwards;\n}\n\n.text2.active {\n    animation: flowUpRight 1s ease-out forwards;\n}\n\n.text3.active {\n    animation: flowDownLeft 1s ease-out forwards;\n}\n\n\n.text4.active {\n    animation: flowDownRight 1s ease-out forwards;\n}\n\n@keyframes flowUpLeft {\n    0% {\n      left: 50%;\n      top: 50%;\n      opacity: 1;\n    }\n    100% {\n      left: 15%;\n      top: 15%;\n      opacity: 0.4;\n    }\n}\n\n\n@keyframes flowUpRight {\n    0% {\n      right: 50%;\n      top: 50%;\n      opacity: 1;\n    }\n    100% {\n      right: 15%;\n      top: 15%;\n      opacity: 0.4;\n    }\n}\n\n@keyframes flowDownRight {\n    0% {\n      right: 50%;\n      bottom: 50%;\n      opacity: 1;\n    }\n    100% {\n      right: -25%;\n      bottom: -25%;\n      opacity: 0.4;\n    }\n}\n\n@keyframes flowDownLeft {\n    0% {\n      left: 50%;\n      bottom: 50%;\n      opacity: 1;\n    }\n    100% {\n      left: 20%;\n      top: 80%;\n      opacity: 0.4;\n    }\n}\n\n\n.animation {\n    position: absolute;\n    font-size: 16px;\n    font-weight: bold;\n    color: #ffffff;\n    animation: flyUp 1.2s ease-out forwards;\n  }\n  \n  @keyframes flyUp {\n    0% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(-100px);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
